/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {
    export interface IFameAdvantageApi extends Meevo.Components.CommonClasses.ICommonDataService {
        loadTimeClockRecordsForReview(criteria: any): ng.IPromise<ITimeClockExportModel[]>;

        loadStudentsFromAdvantageForImport(): ng.IPromise<IImportAdvantageData[]>;

        loadStudentsFromAdvantageForUpdate(): ng.IPromise<IImportAdvantageData[]>;

        getSettings(): ng.IPromise<IAdvantageSettings>;

        testConnection(data: IAdvantageTestConnectModel): ng.IPromise<boolean>;

        importStudents(data: IImportModel): ng.IPromise<IImportRes>;

        updateStudents(data: IImportModel): ng.IPromise<IImportRes>;
    }

    export class FameAdvantageApi extends Meevo.Components.CommonClasses.CommonDataServiceBase implements IFameAdvantageApi {

        static factory(): Function {
            const instance = (
                appSettings: Meevo.Components.Common.IAppSettings,
                $http: angular.IHttpService,
                $q: ng.IQService
            ) => {
                return new FameAdvantageApi(appSettings, $http, $q);
            };

            instance.$inject = [
                'meevo.AppSettings',
                '$http',
                '$q'
            ];

            return instance;
        }

        private get baseUrl(): string {
            return `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.fameAdvantage}`;
        }

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $http: angular.IHttpService,
            protected $q: ng.IQService
        ) {
            super(appSettings, $http);
        }

        public loadTimeClockRecordsForReview(criteria: any): ng.IPromise<ITimeClockExportModel[]> {
            return this.$http.post<ITimeClockEmployee[]>(`/${this.appSettings.API_ROOT}/FameAdvantage/TimeClock/Actual/list`, criteria)
                .then(({data}) => {
                    return data.reduce((studentList: ITimeClockExportModel[], current: ITimeClockEmployee) => {
                        for (const day of current.days) {
                            for (const clock of day.clocks) {
                                studentList.push(new DayTimeClockExportModel(current, day, clock));

                                for (const breakClock of clock.breaks) {
                                    studentList.push(new BreakTimeClockExportModel(current, day, breakClock));
                                }
                            }
                        }

                        return studentList;
                    }, []) as ITimeClockExportModel[];
                });
        }

        public loadStudentsFromAdvantageForImport(): ng.IPromise<IImportAdvantageData[]> {
            return this.$http.get<IFameStudent[]>(`${this.baseUrl}/import`)
                .then((response) => response.data.map((item) => ({fameStudent: item})));
        }

        public loadStudentsFromAdvantageForUpdate(): ng.IPromise<IImportAdvantageData[]> {
            return this.$http.get<IImportAdvantageData[]>(`${this.baseUrl}/update`)
                .then((response) => response.data);
        }

        public importStudents(data: IImportModel): ng.IPromise<IImportRes> {
            return this.$http.post<IImportRes>(`${this.baseUrl}/import`, data)
                .then((response) => response.data);
        }

        public updateStudents(data: IImportModel): ng.IPromise<IImportRes> {
            return this.$http.put<IImportRes>(`${this.baseUrl}/update`, data)
                .then((response) => response.data);
        }

        public getSettings(): ng.IPromise<IAdvantageSettings> {
            return this.$http.get<IAdvantageSettings>(`${this.baseUrl}/fameAdvantageSettings`)
                .then((response) => response.data);
        }

        public testConnection(data: IAdvantageTestConnectModel): ng.IPromise<boolean> {
            return this.$http.post<IAdvantageTestConnectRes>(`${this.baseUrl}/TestConnection`, data)
                .then((response) => response.data.success)
                .catch(() => false);
        }
    }

    angular.module('meevo.plugins.fameAdvantage')
        .service('meevo.plugins.fameAdvantage.fameAdvantageApi', FameAdvantageApi.factory());
}
